<template>
    <template v-if="chartItem.type">
        <ChartComponent
            :index="chartIndex"
            :chartData="chartItem"
            :chartClass="chartItemClass"
        />
    </template>
</template>
<script>
/*
This component is used for rendering single charts
 */
import ChartComponent from '@vueapp/components/ChartComponent.vue'
export default {
    name: 'SingleChartComponent',
    components: {
        ChartComponent
    },
    props: {
        // index: String,
        // chartData: Object,
        chartClass: String,
        postSlug: String,
        postId: String,
        verticalRatio: String,
        columnRatio: String,
        verticalSpan: String
    },
    data() {
        return {
            templateData: {},
        }
    },
    methods: {

    },
    computed: {
        chartItem() {
            if(!this.templateData) return;

            this.templateData.column_ratio = this.columnRatio
            this.templateData.row_span = this.verticalSpan

            return this.templateData ?? {}
        },
        chartIndex() {
            return this.postId
        },
        chartItemClass() {
            // console.log('chartItemClass')
            return 'return-some-class'
        }
    },
    async beforeCreate() {
        const params = new URLSearchParams(window.location.search),
            eParams = {}

        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+\ ]+)$/) ) {
                eParams[name] = value
            }
        })
        const paramsString = ( new URLSearchParams(eParams) ) .toString()

        if(!this.postSlug) return;

        fetch( BRYTER.homeUrl + '/chart/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
            .then(response => response.json())
            .then(data => {
                this.templateData = data.chart_data
                // this.loading = false
            })
    }

}
</script>